import { useEffect, useState } from 'react';

export const useViewportSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const onRizeHandle = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', onRizeHandle);

    return () => {
      window.removeEventListener('resize', onRizeHandle);
    };
  }, []);

  return { ...windowSize };
};
